import { DashboardDto, DashboardMutatePayload } from '@thingslog/repositories';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { DashboardSettingsForm } from '../../forms';
import { DashboardSidebarWidgetCard } from './DashboardSidebarWidgetCard';

interface Props {
  widgetId: string;
  dashboard: DashboardDto | null;
  isPersisting: boolean;
  onPersistDashboard: (
    dashboardId: string,
    payload: DashboardMutatePayload,
    callbacks?: { onSuccess?: () => void }
  ) => void;
  onClose: (widgetId: string) => void;
  onStartTour: () => void;
}

export const DashboardSidebarDashboardEditWidget: FC<Props> = ({
  widgetId,
  dashboard,
  isPersisting,
  onPersistDashboard,
  onClose,
  onStartTour,
}: Props) => {
  const { t } = useTranslation();

  if (!dashboard) {
    return (
      <DashboardSidebarWidgetCard
        title={t('dashboard_edit_dashboard', 'Edit Dashboard')}
        widgetId={widgetId}
        onClose={onClose}
        onStartTour={onStartTour}
      >
        <div className="p-4 text-sm text-gray-600">
          {t('dashboard_no_longer_exists', 'Dashboard no longer exists.')}
        </div>
      </DashboardSidebarWidgetCard>
    );
  }

  return (
    <DashboardSidebarWidgetCard
      title={t('dashboard_edit_named_dashboard', 'Edit {{name}}', {
        name: dashboard.name || t('dashboard_fallback_dashboard', 'Dashboard'),
      })}
      widgetId={widgetId}
      expandable
      onClose={onClose}
      onStartTour={onStartTour}
    >
      <DashboardSettingsForm
        type="edit"
        disabled={isPersisting}
        defaultValues={{
          name: dashboard.name,
          period: dashboard.period,
          colsDesktop: dashboard.colsDesktop,
          colsMobile: dashboard.colsMobile,
          layoutSwitchBreakpointPx: dashboard.layoutSwitchBreakpointPx,
        }}
        onSubmit={(payload: DashboardMutatePayload): void => {
          onPersistDashboard(dashboard.id, payload, { onSuccess: () => onClose(widgetId) });
        }}
        onCancel={(): void => {
          onClose(widgetId);
        }}
      />
    </DashboardSidebarWidgetCard>
  );
};
